export default __webpack_public_path__ + "static/media/logo-extensivo-r3-clinica-medica.812a88f1.svg";